import { render, staticRenderFns } from "./BudgetLoader.vue?vue&type=template&id=b9d83332&scoped=true&"
import script from "./BudgetLoader.vue?vue&type=script&lang=js&"
export * from "./BudgetLoader.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "b9d83332",
  null
  
)

export default component.exports